function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.0642202,7.95412844 C21.4266055,7.95412844 22.5412844,6.84633028 22.5412844,5.47706422 C22.5412844,4.10779817 21.4266055,3 20.0642202,3 C18.6949541,3 17.587156,4.10779817 17.587156,5.47706422 C17.587156,6.84633028 18.6949541,7.95412844 20.0642202,7.95412844 Z M20.2293578,16.4862385 L26.9449541,16.4862385 L26.9449541,14.0091743 L21.956422,14.0091743 L19.2041284,9.4266055 C18.7981651,8.73853211 18.0481651,8.28440367 17.1949541,8.28440367 C16.9610092,8.28440367 16.733945,8.31880734 16.5206422,8.38073394 L9.05504587,10.706422 L9.05504587,17.8623853 L11.5321101,17.8623853 L11.5321101,12.8188073 L14.4288991,11.9174312 L9.05504587,33 L11.5321101,33 L15.4816514,21.8394495 L18.6880734,26.1192661 L18.6880734,33 L21.1651376,33 L21.1651376,24.1857798 L17.7385321,17.9380734 L18.75,13.9885321 L20.2293578,16.4862385 Z",
  fill: "#000000",
  fillRule: "nonzero"
}));

var SvgFootpath = function SvgFootpath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFootpath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/footpath.71b2c821.svg";
export { ForwardRef as ReactComponent };